import { render, staticRenderFns } from "./cashback-form.vue?vue&type=template&id=4b961207&"
import script from "./cashback-form.vue?vue&type=script&lang=js&"
export * from "./cashback-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports